<template>
  <div id="WarningSection">
    <section class="relative z-10 w-full bg-bg_white">
      <div
        class="relative z-10 w-full px-10 mx-auto max-w-screen-3xl md:px-10 3xl:px-20 py-28 md:py-40"
      >
        <div
          class="w-full px-7 mb-20 md:px-10 pt-10 md:pt-14 pb-7 md:pb-10 relative z-10 border-[1.5px] border-primary rounded-sm"
        >
          <header
            class="absolute top-0 z-10 flex items-center px-2 transform -translate-y-1/2 w-fit left-5 bg-bg_white"
          >
            <span class="block mr-2 w-7 h-7 md:w-10 md:h-10">
              <img
                src="/img/notice_icon.webp"
                alt="防詐騙提醒"
                class="block w-full m-auto"
              />
            </span>
            <p class="text-2xl font-black md:text-3xl text-primary">
              防詐騙提醒
            </p>
          </header>
          <ul
            class="w-full text-sm text-justify list-disc list-inside md:text-base text-primary"
          >
            <li v-for="item in scam_tips_list" :key="`scam_tips_${item}`">
              {{ item }}
            </li>
          </ul>
        </div>

        <ol
          class="flex flex-wrap items-center justify-start mb-5 -mx-5 2xl:mx-0"
        >
          <li
            v-for="item_index in 6"
            :key="`warning_${item_index}`"
            class="w-full px-5 md:mb-16 md:w-1/2 lg:w-1/3"
          >
            <div
              class="flex items-center pb-10 border-b md:border-b-0 md:pb-0 border-zinc-100"
            >
              <div class="flex-shrink-0 mr-5 w-14 sm:w-20 aspect-square">
                <img
                  :src="$ImageUrl($GetColumn(`scam_info_${item_index}_image`))"
                  :alt="$GetColumn(`scam_info_${item_index}_title`)"
                  class="block object-contain w-full h-full"
                />
              </div>
              <div>
                <p class="mb-2 text-lg font-bold text-primary">
                  {{ $GetColumn(`scam_info_${item_index}_title`) }}
                </p>
                <p
                  class="text-sm text-zinc-500 preformatted"
                  v-html="$GetColumn(`scam_info_${item_index}_content`)"
                ></p>
              </div>
            </div>
          </li>
        </ol>

        <div
          class="w-full mb-10 text-sm leading-loose text-zinc-500 editor_content"
          v-html="$GetColumn('scam_warning_1_content')"
        ></div>

        <div
          class="w-full text-sm leading-loose text-zinc-500 editor_content"
          v-html="$GetColumn('scam_warning_2_content')"
        ></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ContactFooter",
  computed: {
    scam_list() {
      return this.$store.getters.scam_list;
    },
    scam_tips_list() {
      let content = this.$GetColumn("scam_tips_content");
      if (!content) {
        return [];
      }
      return content.split(",");
    },
  },
};
</script>
